module.exports = __webpack_public_path__ + "static/media/german_truck_120.591c0ab4.png";